import { Column } from "@faire/web/slate/Layout";
import React from "react";

import { LoadingProductTileSkeleton } from "@faire/retailer/components/LoadingProductTileSkeleton/LoadingProductTileSkeleton";
import { loadingSkeletonTileGrid } from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/styles.css";

const NUM_TILES = 16;

export const SDUIFilterablePaginatedSectionGridLoadingSkeleton = () => {
  return (
    <Column>
      {/* Tiles */}
      <div className={loadingSkeletonTileGrid}>
        {Array.from({ length: NUM_TILES }).map((_, index) => (
          <LoadingProductTileSkeleton key={index} />
        ))}
      </div>
    </Column>
  );
};
